// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"713":"79a36290","980":"79a36290"}[chunkId] + ".css";
};